// extracted by mini-css-extract-plugin
export default {"image_name":"ImageDetailsComponent_image_name__0K1Se","lg":"ImageDetailsComponent_lg__BIGU8","sm":"ImageDetailsComponent_sm__gsXJL"};